import React from 'react';

export function TextBlockIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.69 2H8.31C4.67 2 2.5 4.17 2.5 7.81V16.18C2.5 19.83 4.67 22 8.31 22H16.68C20.32 22 22.49 19.83 22.49 16.19V7.81C22.5 4.17 20.33 2 16.69 2ZM18.17 9.22C17.98 9.59 17.54 9.74 17.16 9.56C15.93 8.94 14.6 8.6 13.25 8.5V16.29C13.25 16.7 12.91 17.04 12.5 17.04C12.09 17.04 11.75 16.7 11.75 16.29V8.5C10.4 8.6 9.07 8.94 7.84 9.56C7.73 9.61 7.61 9.63 7.5 9.63C7.23 9.63 6.96 9.48 6.83 9.22C6.64 8.85 6.79 8.4 7.16 8.21C10.5 6.54 14.49 6.54 17.83 8.21C18.21 8.4 18.36 8.85 18.17 9.22Z"
        fill="currentColor"
      />
    </svg>
  );
}
